import React from 'react';
import classNames from 'classnames';
import { PaymentMethodProps, creditCardType } from './interfaces';
import styles from './PaymentMethod.module.scss';

const CREDIT_CARD_TYPE = {
  Visa: 'visa',
  'American Express': 'amex',
  MasterCard: 'mastercard',
  Discover: 'discover',
  PayPal: 'paypal',
  JCB: 'jcb',
  'Diners Club': 'dinersclub',
};

const PaymentMethod = ({ billingInformation, className }: PaymentMethodProps) => {
  const wrapper = classNames(styles.wrapper, className);
  const cardType = CREDIT_CARD_TYPE[billingInformation.cardType as creditCardType];
  const yearLastTwoDigits = billingInformation.year % 100;

  return (
    <div className={wrapper} data-testid="payment-method-wrapper">
      <div className={styles.cardDetails}>
        <div
          className={classNames(styles.cardType, styles[cardType])}
          data-testid="payment-method-card-type"
        />
        <div className={styles.cardNumber} data-testid="payment-method-card-number">
          •••• {billingInformation.lastFour}
        </div>
        <div className={styles.cardExpiration} data-testid="payment-method-expiration">
          Exp {`${billingInformation.month}/${yearLastTwoDigits}`}
        </div>
      </div>
    </div>
  );
};

export default PaymentMethod;
